'use client'

export { P1 } from './P1'
export { P2 } from './P2'
export { P3 } from './P3'
